export enum AdmissionReasonStatus {
    InActive = 0,
    Active = 1,
}